import React, { useState } from "react";
import FeatherIcon from "feather-icons-react";
import { useTranslation } from "react-i18next";
import useAxios from "../utils/useAxios";

const FileUpload = ({ id, file, setFile, label = "File", fieldName = "file", loading, is_authorized }) => {
    const { t } = useTranslation();
    const api = useAxios();
    const [uploading, setUploading] = useState(false);

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append(fieldName, file);

        setUploading(true);
        try {
            const response = await api.patch(
                `/api/v1.0/tournaments/${id}/`,
                formData
            );
            setFile(response.data.file);
        } catch (error) {
            console.error("File upload error", error);
        } finally {
            setUploading(false);
        }
    };

    const handleRemoveFile = async () => {
        const confirmed = window.confirm(t("Are you sure you want to delete the file?"));
        if (confirmed) {
            const formData = new FormData();
            formData.append("file", "");

            setUploading(true);
            try {
                await api.patch(`/api/v1.0/tournaments/${id}/`, formData);
                setFile(null);
            } catch (error) {
                console.error("File remove error", error);
            } finally {
                setUploading(false);
            }
        }
    };

    return (
        <div className="content_page banner-container" style={{minHeight: 0}}>
            <label>{t(label)}</label>
            {is_authorized && file && <FeatherIcon icon="x" onClick={handleRemoveFile} />}

            <div className={`file-preview materials__container ${!is_authorized && "non-authorized"}`}>
                {uploading || loading ? (
                    <>
                        <FeatherIcon icon="loader"/>
                        <p>{t("Loading")}...</p>
                    </>
                ) : file ? (
                    <>
                        <FeatherIcon icon="file" />
                        {is_authorized ? (
                            <a href={file} download={file.split("/").pop()} target="_blank" rel="noopener noreferrer" style={{ position: "relative", zIndex: 2 }}>
                                {file.split("/").pop()}
                            </a>
                        ) : (
                            <span style={{ color: "var(--primary-color)", textDecoration: "underline" }}>
                                {file.split("/").pop()}
                            </span>
                        )}
                    </>
                ) : (
                    <>
                        <FeatherIcon icon="file" />
                        <p>{t("No file uploaded")}</p>
                    </>
                )}

                {is_authorized ? (
                    <input
                        type="file"
                        name={fieldName}
                        onChange={handleFileChange}
                        style={{
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            top: 0,
                            left: 0,
                            opacity: 0,
                            cursor: "pointer",
                            zIndex: 1
                        }}
                    />
                ) : (
                    <a
                        href={file}
                        download={file && file.split("/").pop()}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            top: 0,
                            left: 0,
                            zIndex: 10
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export default FileUpload;
